import { Injectable } from "@angular/core";
import { HelpAPIConstant } from "../constant/help.constant";
import { RestService } from "../../../core/service/rest.service";
import { AttachmentService } from "../../../common/service/attachment.service";
import { ReplacePlantAPIConstant } from "../constant/replace-plant";

@Injectable({
    providedIn: 'root'
})
export class replacePlantService {
    constructor(private rest: RestService, private attachmentService:AttachmentService) { }
 
   
    plantNameList(payload: any) {
         return this.rest.get(ReplacePlantAPIConstant.GET_REPLACE_PLANT_NAME, payload) 
        }
    replacePlantName(oldPlantName: any,newPlantName:any) { 
        return this.rest.post(ReplacePlantAPIConstant.REPLACEPLANT+`?oldPlantName=${oldPlantName}&newPlantName=${newPlantName}`,{})
     }

   
    
}